import './LayoutRoute.less';
import React, { useContext } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { Layout } from 'antd';
import RedirectToMainRoute from './RedirectToMainRoute';
import { APP_CCX, CustomAppContext } from './common/CustomAppContext';
import AppsSider from './common/AppsSider';

const { Content, Sider } = Layout;

interface LayoutRouteProps extends RouteProps {
    component?: React.ComponentType<any>;
    render?: () => React.ReactElement;
    redirectToMain?: boolean;
    exact?: boolean;
    path?: string;
}

export default LayoutRoute;

/**
 * Wraps the route render with layout
 * @param component
 * @param render
 * @param redirectToMain
 * @param routeProps
 * @returns {*}
 * @constructor
 */
function LayoutRoute({
    component,
    render,
    redirectToMain,
    ...routeProps
}: LayoutRouteProps): JSX.Element {
    /**
     * Renders the route content wrapping with defaut layout
     * @returns {*}
     */

    const { currentApp } = useContext(CustomAppContext);

    function renderWithLayout(): JSX.Element {
        return (
            <Layout data-testid="app-layout" className="LayoutRoute-layout">
                <Sider
                    width={'60vw'}
                    className={
                        currentApp === APP_CCX
                            ? 'LayoutRoute-sider-ccx'
                            : 'LayoutRoute-sider-bn'
                    }
                >
                    <AppsSider />
                </Sider>
                <Content
                    data-testid="app-content"
                    className="LayoutRoute-content"
                >
                    {render ? render() : React.createElement(component)}
                </Content>
            </Layout>
        );
    }

    return redirectToMain ? (
        <RedirectToMainRoute
            {...routeProps}
            render={() => renderWithLayout()}
        />
    ) : (
        <Route {...routeProps} render={() => renderWithLayout()} />
    );
}
